<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col-12" id="drag-area">
            <draggable v-model="reports" @end="changeOrderList">
              <div
                v-for="(item, order) in reports"
                :key="order"
                class="row item-report"
              >
                <div class="col-lg-7" style="position: relative;">
                  <div>
                    <font-awesome-icon
                      :icon="['fas', 'ellipsis-v']"
                      class="ellipsis"
                    />
                    <input
                      type="text"
                      readonly
                      class="form-control reportname"
                      v-model="item.reportName"
                    />
                  </div>
                </div>
                <div class="col-lg-3 mb-2">
                  <input
                    type="text"
                    class="form-control"
                    readonly
                    v-model="item.reportType"
                  />
                </div>
                <div
                  class="col-lg-2 text-left mb-2"
                  style="white-space: nowrap;"
                >
                  <button
                    @click="removeReport(item._id)"
                    title="Remover relatório"
                    class="btn btn-outline-danger"
                  >
                    <font-awesome-icon :icon="['fas', 'trash-alt']" />
                  </button>
                  <button
                    v-b-modal.modal-edit-report
                    class="btn btn-outline-primary"
                    title="Editar"
                    @click="setCurrentEdit(item)"
                  >
                    <font-awesome-icon :icon="['fas', 'edit']" />
                  </button>
                  <button
                    v-if="item.reportType !== 'geral'"
                    @click="loadCompanyList(item._id)"
                    title="Ativar empresas"
                    class="btn btn-outline-primary"
                  >
                    <font-awesome-icon :icon="['fas', 'bolt']" />
                  </button>
                </div>
              </div>
            </draggable>
          </div>
        </div>
        <idx-card
          :title="`${this.$t('menu.masterSettings.titleNewReport')}`"
          icon="chart-bar"
          id="reports-idx-card"
        >
          <div class="body">
            <div class="row">
              <div class="col-xl-5">
                <div class="form-group">
                  <label for="report-name"
                    >{{ this.$t('menu.masterSettings.labels.name') }}:</label
                  >
                  <input
                    type="text"
                    v-model="reportName"
                    id="report-name"
                    class="form-control"
                    :placeholder="`${this.$t(
                      'menu.masterSettings.placeholderReportsName',
                    )}`"
                    @keyup="removeInvalidClass('report-name')"
                  />
                  <div class="invalid-feedback">
                    {{ this.$t('menu.masterSettings.feedbackInformReport') }}
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label for="select-type"
                    >{{
                      this.$t('menu.masterSettings.labels.application')
                    }}:</label
                  >
                  <b-form-select
                    id="select-type"
                    v-model="reportType.myReport"
                    :options="reportType.options"
                  >
                  </b-form-select>
                </div>
              </div>
              <div class="col-xl-3 button-area">
                <button @click="addReport" class="btn btn-primary ml-auto">
                  {{ this.$t('menu.masterSettings.buttonRegister') }}
                </button>
              </div>
              <div class="col-xl-12" v-if="reportType.myReport === 'powerbi'">
                <input
                  type="text"
                  v-model="pbiId"
                  id="report-id"
                  class="form-control mb-3"
                  placeholder="ID do relatório"
                />

                <input
                  type="text"
                  v-model="pbiGroupId"
                  id="report-group-id"
                  class="form-control"
                  placeholder="ID do grupo"
                />

                <b-form-group class="mt-2">
                  <b-form-checkbox
                    id="activate-panels"
                    size="sm"
                    v-model="filterPaneEnabled"
                    title="Ativar paineis"
                  >
                    Ativar paineis
                  </b-form-checkbox>

                  <b-form-checkbox
                    id="activate-navigation"
                    size="sm"
                    v-model="pageNavigation"
                    title="Ativar paineis"
                  >
                    Ativar navegação
                  </b-form-checkbox>

                  <b-form-checkbox
                    id="activate-rls"
                    size="sm"
                    v-model="rls"
                    title="Ativar paineis"
                  >
                    Ativar RLS
                  </b-form-checkbox>
                </b-form-group>
              </div>
            </div>
          </div>
        </idx-card>
      </div>
      <div class="col-6 mt-4" v-if="hasReportSelected">
        <div class="row">
          <div class="col-7">
            <div class="search-companies" style="margin-left: 3.5rem;">
              <input
                type="text"
                class="form-control"
                id="input-company"
                :placeholder="`${this.$t(
                  'menu.masterSettings.placeholderSearch',
                )}`"
                v-model="filter"
                @keyup="filterCompanies"
              />

              <button
                class="btn btn-outline-primary"
                :title="`${this.$t('menu.masterSettings.clear')}`"
                @click="cleanFilter"
              >
                {{ this.$t('menu.masterSettings.clear') }}
              </button>
            </div>
          </div>
        </div>
        <div class="row" style="margin-left: 3rem;">
          <div class="col-12 mt-4">
            <b-table
              striped
              :items="companies"
              :fields="fieldsCompany"
              :busy="loading"
              responsive
            >
              <template v-slot:cell(activate)="row">
                <div class="text-center">
                  <b-form-checkbox
                    :id="`activate-report-${row.item._id}`"
                    switch
                    size="lg"
                    v-model="row.item.active"
                    title="Ativa Relatório"
                    v-on:change="
                      activateDeactivateReport(row.item._id, row.item.active)
                    "
                  >
                  </b-form-checkbox>
                </div>
              </template>
            </b-table>
            <div v-show="!loading" class="pagination-area-config-company">
              <paginate
                :pageCount="totalCompanies"
                v-model="page"
                :prevText="'‹'"
                :nextText="'›'"
                :activeClass="'active'"
                :containerClass="'pagination b-pagination'"
                :pageClass="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      title="Editar"
      id="modal-edit-report"
      @ok="updateReport()"
      cancel-title="Cancelar"
    >
      <div class="body">
        <div class="row">
          <div class="col-xl-6">
            <div class="form-group">
              <label for="report-name"
                >{{ this.$t('menu.masterSettings.labels.name') }}:</label
              >
              <input
                type="text"
                v-model="reportEdit.reportName"
                id="report-name"
                class="form-control"
                :placeholder="`${this.$t(
                  'menu.masterSettings.placeholderReportsName',
                )}`"
                @keyup="removeInvalidClass('report-name')"
              />
              <div class="invalid-feedback">
                {{ this.$t('menu.masterSettings.feedbackInformReport') }}
              </div>
            </div>
          </div>
          <div class="col-xl-6">
            <div class="form-group">
              <label for="select-type"
                >{{ this.$t('menu.masterSettings.labels.application') }}:</label
              >
              <b-form-select
                id="select-type"
                v-model="reportEdit.reportType.myReport"
                :options="reportType.options"
              >
              </b-form-select>
            </div>
          </div>
          <div
            class="col-xl-12"
            v-if="reportEdit.reportType.myReport === 'powerbi'"
          >
            <input
              type="text"
              v-model="reportEdit.pbiId"
              id="report-id"
              class="form-control mb-3"
              placeholder="ID do relatório"
            />

            <input
              type="text"
              v-model="reportEdit.pbiGroupId"
              id="report-group-id"
              class="form-control"
              placeholder="ID do grupo"
            />

            <b-form-group class="mt-2">
              <b-form-checkbox
                id="activate-panels"
                size="sm"
                v-model="reportEdit.filterPaneEnabled"
                title="Ativar paineis"
              >
                Ativar paineis
              </b-form-checkbox>

              <b-form-checkbox
                id="activate-navigation"
                size="sm"
                v-model="reportEdit.pageNavigation"
                title="Ativar paineis"
              >
                Ativar navegação
              </b-form-checkbox>

              <b-form-checkbox
                id="activate-rls"
                size="sm"
                v-model="reportEdit.rls"
                title="Ativar paineis"
              >
                Ativar RLS
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import IdxCard from '@/components/molecules/idx-card';
import Switch from '@/components/atoms/switch';
import api from '@/services/api';

export default {
  components: { Paginate, IdxCard, Switch, draggable },

  data: () => ({
    userAuth: null,
    filter: null,
    typingTimer: null,
    reportName: null,
    pbiId: null,
    pbiGroupId: null,
    filterPaneEnabled: false,
    pageNavigation: false,
    rls: false,
    reports: [],
    companies: [],
    reportCompanies: [],
    totalCompanies: 0,
    hasReportSelected: false,
    selectedReport: null,
    reportType: {
      myReport: 'geral',
      options: [],
    },
    fieldsCompany: [],
    fieldsReport: [],
    file: null,
    page: 1,
    reportEdit: {
      pbiId: null,
      pbiGroupId: null,
      rls: false,
      filterPaneEnabled: false,
      pageNavigation: false,
      reportName: null,
      reportType: {
        myReport: 'geral',
        options: [],
      },
    },
  }),

  computed: {
    ...mapFields('master', ['loading']),
    ...mapState('authentication', ['userProfile']),
  },

  watch: {
    page: function watchPage(value) {
      this.updateTable(value);
    },
  },

  methods: {
    async updateReport() {
      await api.put(
        `/reports/${this.reportId}`,
        {
          ...this.reportEdit,
          reportType: this.reportEdit.reportType.myReport,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
      await swal({
        title: this.$t('menu.masterSettings.messages.addReport.title'),
        text: this.$t('menu.masterSettings.messages.addReport.description'),
        icon: 'success',
      });
      this.getReports();
    },
    setCurrentEdit(item) {
      this.reportId = item._id;
      this.reportEdit = {
        pbiId: item.pbiId,
        pbiGroupId: item.pbiGroupId,
        filterPaneEnabled: item.filterPaneEnabled,
        pageNavigation: item.pageNavigation,
        rls: item.rls,
        reportName: item.reportName,
        reportType: {
          myReport: item.reportType,
          options: this.reportType.options,
        },
      };
    },
    async changeOrderList() {
      await this.fixReportListOrder();
      await swal({
        title: this.$t('menu.masterSettings.messages.changeOrderList.title'),
        text: this.$t(
          'menu.masterSettings.messages.changeOrderList.description',
        ),
        icon: 'success',
      });
    },
    async getReports() {
      const { data } = await api.get(`/reports`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });
      this.reports = data;
    },

    async addReport() {
      if (this.validateFields()) {
        await api.post(
          `/reports`,
          {
            reportName: this.reportName,
            reportType: this.reportType.myReport,
            order: this.reports.length + 1,
            pbiId: this.pbiId,
            pbiGroupId: this.pbiGroupId,
            filterPaneEnabled: this.filterPaneEnabled,
            pageNavigation: this.pageNavigation,
            rls: this.rls,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
        await swal({
          title: this.$t('menu.masterSettings.messages.addReport.title'),
          text: this.$t('menu.masterSettings.messages.addReport.description'),
          icon: 'success',
        });
        this.reportName = null;
        this.pbiId = null;
        this.pbiGroupId = null;
        this.getReports();
      }
    },

    async loadCompanyList(id) {
      this.selectedReport = id;
      this.hasReportSelected = true;
      await this.getReportCompanies(id);
      await this.getCompanies();
    },

    async getReportCompanies(id) {
      this.reportCompanies = [];
      const { data } = await api.get(`/report-companies`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          reportId: id,
        },
      });
      this.reportCompanies = data;
    },

    async getCompanies() {
      this.companies = [];
      const { data } = await api.get(`/companies`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          page: this.page,
          limit: '10',
          filter: this.filter,
        },
      });
      this.companies = data.companies;
      for (let i = 0; i < this.companies.length; i += 1) {
        const index = this.reportCompanies.findIndex(
          // eslint-disable-next-line eqeqeq
          (val) => val.companyId == this.companies[i]._id,
        );
        if (index < 0) {
          this.companies[i].active = false;
        } else {
          this.companies[i].active = true;
        }
      }
      this.totalCompanies = Math.ceil(data.total / 10);
    },

    removeReport(id) {
      swal({
        title: this.$t('menu.masterSettings.messages.removeReport.title'),
        text: this.$t('menu.masterSettings.messages.removeReport.description'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.reports.length; i++) {
            if (this.reports[i]._id === id) {
              this.reports.splice(i, 1);
              break;
            }
          }
          await api.delete(`/reports/${id}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          });
          await swal(
            this.$t('menu.masterSettings.removedReport'),
            '',
            'success',
          );
          await this.fixReportListOrder();
          await this.updateTable();
          this.hasReportSelected = false;
        }
      });
    },

    async fixReportListOrder() {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.reports.length; i++) {
        this.reports[i].order = i + 1;
      }
      await api.put(
        `/reports`,
        {
          reports: this.reports,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async activateDeactivateReport(companyId, active) {
      if (active) {
        await this.activateReport(companyId);
      } else {
        await this.deactivateReport(companyId);
      }
    },

    async activateReport(companyId) {
      await api.post(
        `/report-companies`,
        {
          reportId: this.selectedReport,
          companyId,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async deactivateReport(companyId) {
      let removeId;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.reportCompanies.length; i++) {
        // eslint-disable-next-line
        if (this.reportCompanies[i].companyId == companyId &&
          // eslint-disable-next-line
          this.reportCompanies[i].reportId == this.selectedReport) {
          removeId = this.reportCompanies[i]._id;
          break;
        }
      }
      if (removeId) {
        await api.delete(`/report-companies/${removeId}`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
      }
    },

    async updateTable() {
      this.loading = true;
      await this.getReports();
      this.loading = false;
      if (this.hasReportSelected) {
        this.loadCompanyList(this.selectedReport);
      }
    },

    filterCompanies() {
      if (this.filter) {
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      } else if (this.filter === '') {
        this.filter = null;
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      }
    },

    cleanFilter() {
      if (this.filter) {
        this.filter = null;
        this.page = 1;
        this.updateTable();
      }
    },

    removeInvalidClass(id) {
      const element = document.getElementById(id);
      for (let i = 0; i <= element.classList.length; i += 1) {
        if (element.classList[i] === 'is-invalid') {
          element.classList.remove('is-invalid');
        }
      }
    },

    validateFields() {
      if (!this.reportName) {
        document.getElementById('report-name').classList.add('is-invalid');
        return false;
      } else if (!this.reportType.myReport) {
        return false;
      }
      return true;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.updateTable();

    this.reportType.options = [
      { value: 'geral', text: this.$t('menu.masterSettings.general') },
      { value: 'especifico', text: this.$t('menu.masterSettings.specific') },
      { value: 'powerbi', text: 'PowerBI' },
    ];

    this.reportEdit.reportType.options = [
      { value: 'geral', text: this.$t('menu.masterSettings.general') },
      { value: 'especifico', text: this.$t('menu.masterSettings.specific') },
      { value: 'powerbi', text: 'PowerBI' },
    ];

    this.fieldsCompany = [
      { key: 'name', label: this.$t('menu.masterSettings.labels.client') },
      { key: 'cnpj', label: this.$t('menu.masterSettings.labels.cnpj') },
      {
        key: 'activate',
        label: this.$t('menu.masterSettings.labels.activate'),
        class: 'text-center',
      },
    ];

    this.fieldsReport = [
      {
        key: 'reportName',
        label: this.$t('menu.masterSettings.labels.report'),
      },
      {
        key: 'reportType',
        label: this.$t('menu.masterSettings.labels.application'),
      },
      { key: 'options', label: this.$t('menu.masterSettings.labels.actions') },
    ];
  },
  mounted() {
    if (this.userProfile.type !== 'master') {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.search-companies {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.body {
  padding: 20px 15px;
  border-top: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  .button-area {
    display: flex;
    flex-direction: row;
    align-items: center;
    max-height: 86px;

    button {
      margin-top: 14px;
    }
  }

  .custom-area {
    display: flex;
    flex-direction: row;

    input {
      max-width: 120px;
    }
  }
}

.screen {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
}

.pagination-area-config-company >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.table-responsive {
  max-height: 450px;
  scroll-behavior: auto;
}
</style>

<style>
#reports-table td {
  padding: 5px !important;
  vertical-align: middle !important;
}
#reports-idx-card .idx-card-body {
  padding-top: 0px;
}
.pagination-area-config-company .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-config-company a {
  outline: none;
}
.item-report {
  cursor: move;
}
.ellipsis {
  float: left;
  margin-top: 10px;
  color: #c1c1c1;
  position: absolute;
}
.reportname {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/master/master-reports/index.vue